import { ga, adjust } from 'js/analytics/adapters'

export const trackStartRegistration = () => {
  ga.track('Start Registration')
  adjust.track('Start Registration')
}
